<template>
    <div class="page">
        <div class="iframe-box">
            <iframe :src='url' class='iframe'></iframe>
        </div>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addMppAppDecor"
                    >新建</el-button>
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-edit"-->
<!--                        :disabled="multipleSelection.length != 1"-->
<!--                        @click="editMppAppDecor(null)"-->
<!--                    >修改</el-button>-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteMppAppDecor(null)"-->
<!--                    >删除</el-button>-->
                </div>
                <div class="icon-group">
                    <span
                        class="icon-box"
                        @click="refreshMppAppDecorList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="mppAppDecorList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="decorName"
                    label="模板名称"
                > </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="decorContent"
                    label="模板内容"
                    width="180"
                >
                    <template slot-scope="scop">
                        <div>{{ scop.row.decorContent ? scop.row.decorContent : '空' }}</div>
                    </template>
                </el-table-column> -->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="remarks"
                    label="模板备注"
                > </el-table-column>
                <!--el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isIndex"
                    label="菜单首页"
                >
                    <template slot-scope="scop">
                        <div>{{computeYesNo(scop.row.isIndex)}}</div>
                    </template>
                </el-table-column-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkMppAppDecor(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppAppDecor(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="editTemplate(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">编辑模板</span>
                            </div>
                            <div @click="deleteMppAppDecor(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="mppAppDecorStates[mppAppDecorState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="mppAppDecor"
                        ref="mppAppDecorForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="模板名称"
                            prop="decorName"
                        >
                            <el-input
                                size="small"
                                style="width:186px"
                                v-model="mppAppDecor.decorName"
                                :disabled="mppAppDecorState == 'check'"
                            ></el-input>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="模板内容"-->
<!--                            prop="decorContent"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="mppAppDecor.decorContent"-->
<!--                                :disabled="mppAppDecorState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="模板备注"
                            prop="remarks"
                        >
                            <el-input
                                size="small"
                                style="width:186px"
                                v-model="mppAppDecor.remarks"
                                :disabled="mppAppDecorState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <!--el-form-item
                            label="菜单首页"
                            prop="isIndex"
                        -->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="mppAppDecor.isIndex"-->
<!--                                :disabled="mppAppDecorState == 'check'"-->
<!--                            ></el-input>-->
                            <!--el-select
                                size="small"
                                style="width:186px"
                                v-model="mppAppDecor.isIndex"
                                :disabled="mppAppDecorState == 'check'"
                            >
                                <el-option
                                    v-for="(item,index) in yesOrNoEnumList"
                                    :key="index"
                                    :label="item.value"
                                    :value="item.key"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item-->
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="mppAppDecorState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppAppDecorList();
                this.getMppAppDecorList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppAppDecorList();
                this.getMppAppDecorList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            yesOrNoEnumList: [],
            url: "",

            queryForm:{
                id: '', //ID
                decorName: '', //模板名称
                //decorContent: '', //模板内容
                remarks: '', //模板备注
                isIndex: '', //是否激活
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppAppDecorState: 'add',
            mppAppDecorStates: {
                add: '新建装修模板',
                check: '查看装修模板',
                edit: '修改装修模板'
            },

            multipleSelection: [],
            mppAppDecorList: [],
            mppAppDecor: {
                id: '', //ID
                decorName: '', //模板名称
                //decorContent: '', //模板内容
                remarks: '', //模板备注
                isIndex: '', //是否激活
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                decorName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
                decorContent: [{ required: true, message: '模板内容不能为空', trigger: 'blur' }],
                // remarks: [{ required: true, message: '模板备注不能为空', trigger: 'blur' }],
                isIndex: [{ required: true, message: '菜单首页不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getMppAppDecorList();
        this.getYesOrNoEnum();
        this.getUrl();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        resetMppAppDecorList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppAppDecorList = [];
        },
        resetDialog() {
            this.mppAppDecorState = 'add';
            this.showDialog = false;
            this.queryForm = {
                id: '', //ID
                decorName: '', //模板名称
                //decorContent: '', //模板内容
                remarks: '', //模板备注
                isIndex: '', //是否激活
            };
            this.getMppAppDecorList();
        },
        closeDialog() {
            this.showDialog = false
            this.mppAppDecor = {
                id: '', //ID
                decorName: '', //模板名称
                //decorContent: '', //模板内容
                remarks: '', //模板备注
                isIndex: '', //是否激活
            };
        },
        submitForm() {
            delete this.mppAppDecor.decorContent
            if (this.mppAppDecorState == 'add') {
                this.$refs.mppAppDecorForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/appdecor/add`,{ ...this.mppAppDecor }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetMppAppDecorList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mppAppDecorState == 'edit') {
                this.$refs.mppAppDecorForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/appdecor/edit`,{ ...this.mppAppDecor }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppDecorList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMppAppDecor() {
            this.showDialog = true;
            this.mppAppDecorState = 'add';
        },
        checkMppAppDecor(mppAppDecorId) {
            console.log(mppAppDecorId);
            this.currentMppAppDecorId = mppAppDecorId;

            this.getMppAppDecorById();
            this.showDialog = true;
            this.mppAppDecorState = 'check';
        },
        editMppAppDecor(mppAppDecorId) {
            console.log('mppAppDecor', mppAppDecorId);
            if (mppAppDecorId) {
                this.currentMppAppDecorId = mppAppDecorId;
                this.getMppAppDecorById();
            } else {
                this.mppAppDecor = { ...this.mppAppDecor, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppAppDecorState = 'edit';
        },
        editTemplate(mppAppDecorId){
            this.$router.push('/Decoration/Decoration?id=' + mppAppDecorId)
        },
        deleteMppAppDecor(mppAppDecorId) {
            let ids = '';
            if (mppAppDecorId) {
                ids = mppAppDecorId;
            } else {
                ids = this.multipleSelection.map((mppAppDecor) => mppAppDecor.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/appdecor/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppAppDecorList();
                            this.getMppAppDecorList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshMppAppDecorList() {
            this.resetMppAppDecorList();
            this.getMppAppDecorList();
        },
        getMppAppDecorList(query = {}) {
            this.loading = true;
            get(`/mpp/appdecor/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppAppDecorList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMppAppDecorById() {
            get(`/mpp/appdecor/get`,{ id: this.currentMppAppDecorId }).then((res) =>{
                if(res.success){
                    this.mppAppDecor = { ...this.mppAppDecor, ...res.mppAppDecor };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppAppDecorList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/appdecor/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/appdecor/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/appdecor/importData`,formData);
            this.refreshMppAppDecorList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppAppDecorList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppAppDecorList();
        },
        // 获取 YesOrNoEnum
        getYesOrNoEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.yesOrNoEnumList = res.enumList;
                }
            });
        },
        // 计算是否
        computeYesNo(type) {
            for (let i = 0; i < this.yesOrNoEnumList.length; i++) {
                if (this.yesOrNoEnumList[i].key == type) {
                    return this.yesOrNoEnumList[i].value;
                }
            }
        },

        // 获取装修预览url
        getUrl(){
            get("/mpp/utils/getDecorPreviewURL").then((res)=>{
                if(res.success){
                    this.url = res.url
                }
            })
        }
    }

};
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    display: flex;
    flex-direction: row;
    .page-content{
        width: 70%;
    }
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.iframe-box {
    position: relative;
    min-width: 300px;
    height: 100%;
    padding: 10px;
    background-color: #fff;

    .iframe {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        border: 1px solid #eee;
        overflow: hidden;
    }

    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>